import { render, staticRenderFns } from "./PromotedBuyBoxNew.vue?vue&type=template&id=0a058ad4&scoped=true"
import script from "./PromotedBuyBoxNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromotedBuyBoxNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PromotedBuyBoxNew.vue?vue&type=style&index=0&id=0a058ad4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a058ad4",
  null
  
)

export default component.exports